module.exports = __webpack_public_path__ + "img/footer-logo.13b5d64.png";